import { BaseNode, BaseNodeProps } from "./BaseNode";
import { NodeData } from "../types";
import PlayIcon from "lucide-react/dist/esm/icons/play";
import ClockIcon from "lucide-react/dist/esm/icons/clock";
import LinkIcon from "lucide-react/dist/esm/icons/link";

interface TriggerNodeProps extends BaseNodeProps {
  data: NodeData & {
    triggerType?: "manual" | "interval" | "webhook" | "event" | "email";
    intervalValue?: number;
    intervalUnit?: "minute" | "hour" | "day" | "month";
  };
  id: string;
}

export function TriggerNode({ data, onAddAction, ...props }: TriggerNodeProps & { onAddAction?: () => void }) {
  const getIcon = () => {
    switch (data.triggerType) {
      case "interval":
        return <ClockIcon />;
      case "webhook":
        return <LinkIcon />;
      default:
        return <PlayIcon />;
    }
  };

  const getColor = () => {
    switch (data.triggerType) {
      case "interval":
        return "bg-purple-500 dark:bg-purple-800";
      case "webhook":
        return "bg-linear-to-r from-green-500 to-green-600 border border-green-400 dark:bg-green-800";
      default:
        return "bg-linear-to-r from-blue-500 to-blue-600 border border-blue-400 dark:bg-slate-800";
    }
  };

  const getLabel = () => {
    if (data.triggerType === "interval" && data.intervalValue && data.intervalUnit) {
      return `Every ${data.intervalValue} ${data.intervalUnit}${data.intervalValue > 1 ? "s" : ""}`;
    }
    return data.label;
  };

  return (
    <BaseNode
      data={{ ...data, label: getLabel() }}
      icon={getIcon()}
      color={getColor()}
      {...props}
      onAddAction={onAddAction}
      removeTargetHandle
    />
  );
}
